module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Main-Page.98d74597.jpg";